import Footer from './src/Footer.vue'
import Layout from './src/Layout.vue'
import Header from './src/Header.vue'

export const MicroAppLayout = Layout
export const MicroAppHeader = Header
export const MicroAppFooter = Footer
